export default __webpack_public_path__ + "static/media/O-018.47ac83ca.png";